import { Modal, Col, ButtonGroup, Button, FormGroup } from "reactstrap";

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import Loading from "components/Loading";
import qualityApi from "service/qualityApi";
import { AddBox, EditNote } from "@mui/icons-material";

const Modals = ({
  attendanceId,
  analysisId,
  update,
  setUpdate,
  evaluated,
  promptId,
}) => {
  const { register, handleSubmit, setValue } = useForm();
  const [loading, setLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [checklist, setChecklist] = useState(null);
  const [selectedPrompt, setSelectedPrompt] = useState(null);

  const onSubmit = (data) => {
    if (!data.response?.trim()) {
      return toast.error("Necessário informar a resposta da análise!");
    }

    if (typeof checklist !== "boolean") {
      return toast.error(
        "Necessário informar se a resposta é positiva ou negativa!",
      );
    }

    setLoading(true);
    if (analysisId && evaluated) {
      qualityApi
        .patch(`/attendances/analysis/${analysisId}`, {
          evaluableEventId: promptId,
          response: data.response,
          checklist: checklist,
        })
        .then(() => {
          toast.success("Análise atualizada com sucesso!");
          toast.success("O score sera gerado em alguns minutos.");
          setUpdate(!update);
          setToggle(false);
          setLoading(false);
          return;
        })
        .catch(() => {
          toast.error("Houve um problema ao tentar atualizar a análise");
          setLoading(false);
          return;
        });
      return;
    } else {
      qualityApi
        .post(`/attendances/${attendanceId}/analysis`, {
          evaluableEventId: data.prompt,
          response: data.response,
          checklist: checklist,
        })
        .then(() => {
          toast.success("Análise registrada com sucesso!");
          toast.success("O score sera gerado em alguns minutos.");
          setUpdate(!update);
          setToggle(false);
          setLoading(false);
          return;
        })
        .catch((error) => {
          if (error.response?.data?.statusCode == 500) {
            toast.error(
              "Houve um erro interno ao registrar a análise, tente novamente mais tarde.",
            );
            setToggle(false);
            return;
          }
          toast.error("Houve um problema ao tentar registrar a análise!");
          setLoading(false);
          return;
        });
    }
  };

  const getPrompts = async () => {
    setLoading(true);
    qualityApi
      .get(`evaluable-events/${promptId}`)
      .then((response) => response.data)
      .then((response) => {
        if (response) {
          setSelectedPrompt(response);
          setValue("prompt", promptId);
        }
        setLoading(false);
        return;
      })
      .catch(() => {
        toast.error("Erro ao tentar recuperar os prompts!");
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    if (toggle) {
      getPrompts().then(() => {
        if (toggle && analysisId) {
          setLoading(true);
          qualityApi
            .get(`/attendances/analysis/${analysisId}`)
            .then((response) => response.data)
            .then((response) => {
              if (response) {
                setValue("prompt", response?.evaluableEvent?.id);
                setSelectedPrompt(response?.evaluableEvent);
                setValue("response", response.response);
                setChecklist(response.checklist === "Sim" ? true : false);
              }
              setLoading(false);
              return;
            })
            .catch(() => {
              toast.error("Erro ao tentar recuperar a analise!");
              setLoading(false);
            });
        }
      });
    }
  }, [toggle]);

  return (
    <Col
      md="2"
      style={{
        padding: 0,
      }}
    >
      {evaluated ? (
        <EditNote
          type="button"
          color="action"
          fontSize="large"
          onClick={() => setToggle(true)}
          title="Editar avaliação"
        />
      ) : (
        <AddBox
          type="button"
          color="inherit"
          fontSize="large"
          onClick={() => setToggle(true)}
          title="Adicionar avaliação"
        />
      )}
      <Modal
        className="modal-dialog modal-lg"
        isOpen={toggle}
        toggle={() => setToggle((v) => !v)}
      >
        <div className="modal-header">
          <div className="modal-title">
            <h3>Avaliação</h3>
          </div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setToggle((v) => !v)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          {loading ? <Loading /> : ""}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="pl-lg-2">
              <FormGroup>
                <label className="form-control-label">Pergunta</label>
                <textarea
                  style={{
                    display: "block",
                    width: "100%",
                    height: "100px",
                    resize: "none",
                    padding: "0.625rem 0.75rem",
                    fontSize: "0.875rem",
                    fontWeight: "400",
                    lineHeight: "1.5",
                    color: "#8898aa",
                    backgroundColor: "rgb(249, 249, 249)",
                    backgroundClip: "padding-box",
                    border: "none",
                    borderRadius: "0.375rem",
                    boxShadow: "none",
                    transition:
                      "all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                  }}
                  className="form-control-alternative"
                  id="prompt-question"
                  type="text"
                  disabled={true}
                  value={selectedPrompt?.prompt}
                  autoComplete="off"
                />
              </FormGroup>
            </div>
            <div className="pl-lg-2">
              <FormGroup>
                <label className="form-control-label">Resposta</label>
                <textarea
                  style={{
                    display: "block",
                    width: "100%",
                    height: "100px",
                    resize: "none",
                    padding: "0.625rem 0.75rem",
                    fontSize: "0.875rem",
                    fontWeight: "400",
                    lineHeight: "1.5",
                    color: "#8898aa",
                    backgroundColor: "#fff",
                    backgroundClip: "padding-box",
                    border: "1px solid #cad1d7",
                    borderRadius: "0.375rem",
                    boxShadow: "none",
                    transition:
                      "all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                  }}
                  className="form-control-alternative"
                  id="response"
                  type="text"
                  {...register("response")}
                  autoComplete="off"
                />
              </FormGroup>
            </div>
            <div className="pl-lg-2">
              <FormGroup>
                <label className="form-control-label">
                  Checklist ( informar se a resposta foi positiva ou negativa )
                </label>
                <br />
                <ButtonGroup>
                  <Button
                    color="primary"
                    outline
                    onClick={() => setChecklist(true)}
                    active={checklist === true}
                  >
                    Positiva
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={() => setChecklist(false)}
                    active={checklist === false}
                  >
                    Negativa
                  </Button>
                </ButtonGroup>
              </FormGroup>
            </div>
            <hr className="my-4" />
            <Button type="submit" color="primary" disabled={loading}>
              Salvar
            </Button>
          </form>
        </div>
      </Modal>
    </Col>
  );
};

export default Modals;
